import { Loader2 } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface FixErrorsActionsProps {
  isProperty: boolean;
  loading: boolean;
  onCancel: () => void;
  onBack: () => void;
  onImport: () => void;
}

const FixErrorsActions = ({
  isProperty,
  loading,
  onCancel,
  onBack,
  onImport,
}: FixErrorsActionsProps) => {
  const primaryLabel = isProperty ? 'Import' : 'Checkout';
  const secondaryAction = isProperty ? onCancel : onBack;
  const secondaryLabel = isProperty ? 'Cancel' : 'Back';

  return (
    <footer className="flex shrink-0 items-center justify-between border-t border-border bg-card px-6 py-4">
      <Button type="button" variant="outline" onClick={secondaryAction}>
        {secondaryLabel}
      </Button>
      <Button type="button" disabled={loading} onClick={onImport}>
        {loading && <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />}
        {primaryLabel}
      </Button>
    </footer>
  );
};

export default FixErrorsActions;
